import React from 'react';
import FeedbackTable from './FeedbackTable';

const FeedbackLanding = () => {
    return (
        <>
            <div
                className='page-header'
                role='banner'
            >
                <h1>Feedback</h1>
                <div className='primary-actions'>&nbsp;</div>
            </div>
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <FeedbackTable />
                </div>
            </div>
        </>
    );
};

export default FeedbackLanding;
